import React, { useEffect, useState } from "react";

import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import DataService from "./services/dataService/DataService";
import LibToast from "./lib/LibToast";
import { Helmet } from "react-helmet";
import builMeta from "./buildmeta.json";
import Simulador from "./vista/Simulador";


function App() {
    
    const [isLoaded,setIsLoaded]=useState(false);
    
    useEffect(()=>{
    
    
        setIsLoaded(true);
        
    },[]);
    
    if(!isLoaded){
        return <div className="loading">Iniciando...</div>
    }
    
    
    return (<>
        <Helmet>
            <title>Simualdor de Créditoo :: Vivalia</title>
        </Helmet>
        <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="has-text-center">
                        <img src="https://vivalia.mx/vivalia.png"
                             id="imgLogo"
                             className="mb-logo"
                             alt=""/>
                    </div>
                  
                    <Simulador />
                    <div className="buildInfo" title={builMeta.fecha}>
                        Version {builMeta.version} Build {builMeta.num}
                    </div>
                </div>
            </div>
    
        </div>
    </>)
}

export default App;
